import { render, staticRenderFns } from "./cardComponent.vue?vue&type=template&id=6f7a4458&scoped=true&"
import script from "./cardComponent.vue?vue&type=script&lang=js&"
export * from "./cardComponent.vue?vue&type=script&lang=js&"
import style0 from "./cardComponent.vue?vue&type=style&index=0&id=6f7a4458&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a4458",
  null
  
)

export default component.exports